import React from "react"

const raiseError = function (message) {
  throw new Error(message)
}

const App = (_props) => <div>{raiseError("UI Test Error from AppWithoutErrorBoundary")}</div>

export default App
